import { Theme } from '@mui/material/styles'

export const getStyles = (theme: Theme) => ({
  logoContainer: {
    textAlign: 'center',
  },

  formContainer: {
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
  },

  forgotPass: { display: 'flex' },

  footerContainer: {
    textAlign: 'center',
    position: 'absolute',
    bottom: '31px',
    width: '100%',
  },

  privacyPolicy: {
    color: '#5f6972',
    fontSize: '.8rem',
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
  },

  endLife: {
    color: '#5f6972',
    fontSize: '.8rem',
    paddingLeft: theme.spacing(2),
  },

  terms: {
    color: '#5f6972',
    fontSize: '.8rem',
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
  },

  copyright: { color: '#5f6972', fontSize: '.8rem' },

  total: {
    fontFamily: 'Source Sans Pro Semibold',
    fontSize: '16px',
    margin: `${theme.spacing(1.4)} 0 auto 0`,
  },

  tax: {
    fontSize: '12px',
    color: theme.palette.grey[600],
  },

  smallText: { fontSize: '14px' },

  footerValue: {
    fontSize: '16px',
    fontFamily: 'Source Sans Pro Semibold',
  },

  hint: { color: theme.palette.grey[600] },
  info: { marginLeft: theme.spacing(0.5) },
})
